import React from "react";
import { Compass, Leaf, Sprout } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const ICONS = { compass: Compass, leaf: Leaf, sprout: Sprout };

export default function Logo({ className = "", showText = true }) {
  const { tenant } = useAuth();
  const Icon = ICONS[tenant?.logo_icon] || Compass;
  const hasLogo = !!tenant?.logo_url;
  const isPartner = !!tenant?.slug && tenant.slug !== "fisbo";

  const dominant = hasLogo ? (
    <img
      src={tenant.logo_url}
      alt={`${tenant?.name || "FISBO"} logo`}
      className="h-8 w-auto max-w-[150px] shrink-0 object-contain sm:h-10 sm:max-w-[190px]"
    />
  ) : (
    <span className="flex min-w-0 items-center gap-2.5">
      <span className="grid h-9 w-9 shrink-0 place-items-center rounded-xl" style={{ backgroundColor: "var(--tenant-primary-light)" }}>
        <Icon className="tenant-text" strokeWidth={1.75} size={20} />
      </span>
      {showText && (
        <span className="block truncate font-head text-lg font-semibold text-neutral-900">{tenant?.name || "FISBO Compass"}</span>
      )}
    </span>
  );

  return (
    <div className={`flex min-w-0 items-center gap-3 ${className}`} data-testid="brand-logo">
      {dominant}
      {isPartner && (
        <span className="flex shrink-0 items-center gap-1.5 border-l border-neutral-200 pl-2.5 sm:pl-3" data-testid="brand-secondary-fisbo" aria-label="FISBO Compass">
          <Compass size={15} strokeWidth={1.75} style={{ color: "#2E5C41" }} />
          <span className="hidden font-head text-xs font-medium text-neutral-500 sm:inline">FISBO Compass</span>
        </span>
      )}
    </div>
  );
}
